'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var skin7 = exports.skin7 = '#8B4E30';
var skin6 = exports.skin6 = '#9E623C';
var skin5 = exports.skin5 = '#B2764A';
var skin4 = exports.skin4 = '#C68B58';
var skin3 = exports.skin3 = '#D59E6A';
var skin2 = exports.skin2 = '#E4B07C';
var skin1 = exports.skin1 = '#F2C48E';
var skin = {
  7: skin7,
  6: skin6,
  5: skin5,
  4: skin4,
  3: skin3,
  2: skin2,
  1: skin1
};
exports.default = skin;